import Vue from 'vue'
import Vuex from 'vuex'
import image from '@/assets/images/home-office.jpg'

Vue.use(Vuex)

const {
    getUser,
    setUser,
    removeUser,
    // getToken,
    setToken,
    removeToken,
    setRequestAmt,
} = require('./lib/storage')

const user = getUser()
// const token = getToken()

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: image,
    drawer: null,

    currentUser: user,
    isLogged: !!user,
    loading: false,
    auth_error: null,
  },

  getters: {
    isLoading: state => state.loading,
    isLoggedIn: state => state.isLogged,
    currentUser: state => state.currentUser,
    authError: state => state.auth_error,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },

    LOGIN (state) {
      state.loading = true
      state.auth_error = null
    },
    loginSuccess (state, payload) {
      state.auth_error = null
      state.isLogged = true
      state.loading = false
      state.currentUser = Object.assign({}, payload)
      setUser(JSON.stringify(state.currentUser))
      setToken(payload.accessToken)
   },

  loginFailed (state, payload) {
      state.loading = false
      state.auth_error = payload
      state.access = null
      removeUser()
      removeToken()
  },

  LOGOUT (state) {
      state.isLogged = false
      state.currentUser = null
      removeUser()
      removeToken()
    }
  },
  actions: {
    login (context) {
      context.commit('LOGIN')
    },
    logout (context) {
        context.commit('LOGOUT')
    },
  },
})
